import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import PaperIcon from "../components/PaperIcon"

export default function IconTitleValue({
  Icon,
  title,
  value,
  titleFontSize = "14px",
}) {
  return (
    <Row sx={{ alignItems: "center", gap: 1 }}>
      <PaperIcon>
        <Icon />
      </PaperIcon>
      <Column>
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={titleFontSize}
        >
          {title}
        </Typography>
        <Typography variant="h6" fontWeight={600}>
          {value || "--"}
        </Typography>
      </Column>
    </Row>
  )
}
